import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import ForgotView from '../views/ForgotView.vue'
import ProvisionalEntryView from '../views/ProvisionalEntryView.vue'
import SignUpView from '../views/SignUpView.vue'
import RoomListView from '../views/RoomListView'
import ReserveRoomView from '../views/ReserveRoomView.vue'
import ReserveConfirmView from '../views/ReserveConfirmView.vue'
import ReserveCompleteView from '../views/ReserveCompleteView.vue'
import SignUpResultView from '../views/SignUpResultView.vue'
import SignUpConfirmView from '../views/SignUpConfirmView.vue'
import ResetResultView from '../views/ResetResultView.vue'
import ResetView from '../views/ResetView.vue'
import ReserveCancelView from '../views/ReserveCancelView.vue'


const routes = [
  {
    path: '/',
    name: 'login',
    meta: { layout: 'none' },
    component: LoginView
  },
  {
    path: '/forgot',
    name: 'forgot',
    meta: { layout: 'none' },
    component: ForgotView
  },
  {
    path: '/reset',
    name: 'reset',
    meta: { layout: 'none' },
    component: ResetView
  },
  {
    path: '/resetResult',
    name: 'resetResult',
    meta: { layout: 'none' },
    component: ResetResultView
  },
  {
    path: '/roomList',
    name: 'roomList',
    component: RoomListView
  },
  {
    path: '/reserveRoom',
    name: 'reserveRoom',
    component: ReserveRoomView
  },
  {
    path: '/reserveConfirm',
    name: 'reserveConfirm',
    component: ReserveConfirmView
  },
  {
    path: '/reserveComplete',
    name: 'reserveComplete',
    component: ReserveCompleteView
  },
  {
    path: '/provisionalEntry',
    name: 'provisionalEntry',
    meta: { layout: 'none' },
    component: ProvisionalEntryView
  },
  {
    path: '/signUp',
    name: 'signUp',
    meta: { layout: 'none' },
    component: SignUpView
  },
  {
    path: '/signUpConfirm',
    name: 'signUpConfirm',
    meta: { layout: 'none' },
    component: SignUpConfirmView
  },
  {
    path: '/signUpResult',
    name: 'signUpResult',
    meta: { layout: 'none' },
    component: SignUpResultView
  },
  {
    name: "reserveCancel",
    path: "/reserveCancel",
    component: ReserveCancelView
  },
  {
    name: "404",
    path: "/:catchAll(.*)"
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// リファラーを設定
router.beforeEach((to, from, next) => {
  if (to.name === "404") {
    // console.log(from)
    router.push({ name: "login"})
  }
  window.scrollTo({
    top: 0,
    behavior: "instant"
  });
  router['referrer'] = from;
  next();
})

export default router
